import { FC } from 'react'
import AutomationRuleWizard from './AutomationRuleWizard'

const AutomationRuleCreate: FC = () => <AutomationRuleWizard mode="create" />

export default AutomationRuleCreate
